import * as React from "react";
const SvgDoorOpen20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M4 0H3v20h2V2h2v14.727l.69.224 8 2.6 1.31.426V0H4Zm5 15.274V2h6v15.224l-6-1.95Zm2-4.774a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
      clipRule: "evenodd"
    })
  );
export default SvgDoorOpen20Px;
